(function () {
  function clearThemeAnimationClasses(button) {
    if (!button) return;
    button.querySelectorAll('span, svg').forEach(function (el) {
      el.classList.remove(
        'animated',
        'zoomOut',
        'zoomIn',
        'fadeInDown',
        'fadeOut'
      );
      el.style.animation = '';
      el.style.transform = '';
      el.style.opacity = '';
    });
  }

  function setLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('is-loading', Boolean(isLoading));
    if (isLoading) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
      clearThemeAnimationClasses(button);
    }
  }

  function bindButton(button) {
    if (!button || button.dataset.repolishedBtnReady === 'true') return;
    button.dataset.repolishedBtnReady = 'true';
    button._repolishedAwaitingCart = false;

    // Ensure label is visible on bind
    setLoading(button, false);

    button.addEventListener('click', function () {
      if (button.disabled && !button._repolishedAwaitingCart) return;
      if (!button.hasAttribute('data-repolished-loader')) return;

      if (button.type === 'submit' || button.classList.contains('ajax-submit')) {
        button._repolishedAwaitingCart = true;
        setLoading(button, true);
      }
    });

    var observer = new MutationObserver(function () {
      if (!button._repolishedAwaitingCart) {
        // Don't hide label just because theme toggles disabled for other reasons
        if (!button.classList.contains('is-loading')) {
          clearThemeAnimationClasses(button);
        }
        return;
      }

      var busy =
        button.classList.contains('disabled') ||
        button.hasAttribute('disabled');

      if (busy) {
        setLoading(button, true);
      } else {
        button._repolishedAwaitingCart = false;
        setLoading(button, false);
      }
    });

    observer.observe(button, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
    });

    // Safety: never leave loader stuck
    button.addEventListener('animationend', function () {
      clearThemeAnimationClasses(button);
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('.repolished-btn[data-repolished-loader]').forEach(bindButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
